import { useState, useEffect } from "react";
import styles from "./StatusNotification.module.css";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import SuccessTick from "../SuccessTick/SuccessTick";

export default function StatusNotification({
  isVisible,
  isLoading,
  isSuccess,
  message,
  onComplete,
  autoHide = true,
  hideDelay = 2000,
  successButton = null,
}) {
  const [showSuccess, setShowSuccess] = useState(false);
  const isBusy = isLoading && !showSuccess;

  useEffect(() => {
    if (isSuccess && !isLoading) {
      setShowSuccess(true);

      if (autoHide) {
        const timer = setTimeout(() => {
          setShowSuccess(false);
          onComplete?.();
        }, hideDelay);

        return () => clearTimeout(timer);
      }
    } else {
      setShowSuccess(false);
    }
  }, [isSuccess, isLoading, autoHide, hideDelay, onComplete]);

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.notification}>
        <div
          className={
            isBusy ? `${styles.content} ${styles.contentBusy}` : styles.content
          }
        >
          {isBusy && (
            <>
              <LoadingSpinner />
              <p className={styles.message}>{message || "Processing..."}</p>
            </>
          )}

          {showSuccess && (
            <>
              <SuccessTick size={48} color="#10b981" />
              <p className={styles.successMessage}>{message || "Success!"}</p>
              {successButton && (
                <div className={styles.buttonContainer}>{successButton}</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
